/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Store_Creatorcode_Title1Inputs */

const id_store_creatorcode_title1 = /** @type {(inputs: Store_Creatorcode_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dukung egdata.app`)
};

const ms_store_creatorcode_title1 = /** @type {(inputs: Store_Creatorcode_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sokong egdata.app`)
};

const da_store_creatorcode_title1 = /** @type {(inputs: Store_Creatorcode_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Støt egdata.app`)
};

const de_store_creatorcode_title1 = /** @type {(inputs: Store_Creatorcode_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unterstützen Sie egdata.app`)
};

const en_us2_store_creatorcode_title1 = /** @type {(inputs: Store_Creatorcode_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support egdata.app`)
};

const es_es2_store_creatorcode_title1 = /** @type {(inputs: Store_Creatorcode_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apoya a egdata.app`)
};

const es_mx2_store_creatorcode_title1 = /** @type {(inputs: Store_Creatorcode_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apoya a egdata.app`)
};

const fil_store_creatorcode_title1 = /** @type {(inputs: Store_Creatorcode_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suportahan ang egdata.app`)
};

const fr_store_creatorcode_title1 = /** @type {(inputs: Store_Creatorcode_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soutenir egdata.app`)
};

const it_store_creatorcode_title1 = /** @type {(inputs: Store_Creatorcode_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supporta egdata.app`)
};

const hu_store_creatorcode_title1 = /** @type {(inputs: Store_Creatorcode_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Támogasd az egdata.app-ot`)
};

const nl_store_creatorcode_title1 = /** @type {(inputs: Store_Creatorcode_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Steun egdata.app`)
};

const no_store_creatorcode_title1 = /** @type {(inputs: Store_Creatorcode_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Støtt egdata.app`)
};

const pl_store_creatorcode_title1 = /** @type {(inputs: Store_Creatorcode_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wesprzyj egdata.app`)
};

const pt_br2_store_creatorcode_title1 = /** @type {(inputs: Store_Creatorcode_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suporte egdata.app`)
};

const pt_store_creatorcode_title1 = /** @type {(inputs: Store_Creatorcode_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apoiar egdata.app`)
};

const ro_store_creatorcode_title1 = /** @type {(inputs: Store_Creatorcode_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprijină egdata.app`)
};

const fi_store_creatorcode_title1 = /** @type {(inputs: Store_Creatorcode_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tue egdata.appia`)
};

const sv_store_creatorcode_title1 = /** @type {(inputs: Store_Creatorcode_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stöd egdata.app`)
};

const vi_store_creatorcode_title1 = /** @type {(inputs: Store_Creatorcode_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hỗ trợ egdata.app`)
};

const tr_store_creatorcode_title1 = /** @type {(inputs: Store_Creatorcode_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`egdata.app'i Destekleyin`)
};

const cs_store_creatorcode_title1 = /** @type {(inputs: Store_Creatorcode_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podpořte egdata.app`)
};

const bg_store_creatorcode_title1 = /** @type {(inputs: Store_Creatorcode_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подкрепете egdata.app`)
};

const ru_store_creatorcode_title1 = /** @type {(inputs: Store_Creatorcode_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поддержите egdata.app`)
};

const uk_store_creatorcode_title1 = /** @type {(inputs: Store_Creatorcode_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Підтримайте egdata.app`)
};

const ar_store_creatorcode_title1 = /** @type {(inputs: Store_Creatorcode_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ادعم egdata.app`)
};

const hi_store_creatorcode_title1 = /** @type {(inputs: Store_Creatorcode_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`egdata.app का समर्थन करें`)
};

const th_store_creatorcode_title1 = /** @type {(inputs: Store_Creatorcode_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สนับสนุน egdata.app`)
};

const ja_store_creatorcode_title1 = /** @type {(inputs: Store_Creatorcode_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`egdata.app をサポート`)
};

const zh_cn2_store_creatorcode_title1 = /** @type {(inputs: Store_Creatorcode_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支持 egdata.app`)
};

const zh_hant1_store_creatorcode_title1 = /** @type {(inputs: Store_Creatorcode_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支援 egdata.app`)
};

const ko_store_creatorcode_title1 = /** @type {(inputs: Store_Creatorcode_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`egdata.app 지원하기`)
};

/**
* | output |
* | --- |
* | "Support egdata.app" |
*
* @param {Store_Creatorcode_Title1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const store_creatorcode_title1 = /** @type {((inputs?: Store_Creatorcode_Title1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Store_Creatorcode_Title1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_store_creatorcode_title1(inputs)
	if (locale === "ms") return ms_store_creatorcode_title1(inputs)
	if (locale === "da") return da_store_creatorcode_title1(inputs)
	if (locale === "de") return de_store_creatorcode_title1(inputs)
	if (locale === "en-US") return en_us2_store_creatorcode_title1(inputs)
	if (locale === "es-ES") return es_es2_store_creatorcode_title1(inputs)
	if (locale === "es-MX") return es_mx2_store_creatorcode_title1(inputs)
	if (locale === "fil") return fil_store_creatorcode_title1(inputs)
	if (locale === "fr") return fr_store_creatorcode_title1(inputs)
	if (locale === "it") return it_store_creatorcode_title1(inputs)
	if (locale === "hu") return hu_store_creatorcode_title1(inputs)
	if (locale === "nl") return nl_store_creatorcode_title1(inputs)
	if (locale === "no") return no_store_creatorcode_title1(inputs)
	if (locale === "pl") return pl_store_creatorcode_title1(inputs)
	if (locale === "pt-BR") return pt_br2_store_creatorcode_title1(inputs)
	if (locale === "pt") return pt_store_creatorcode_title1(inputs)
	if (locale === "ro") return ro_store_creatorcode_title1(inputs)
	if (locale === "fi") return fi_store_creatorcode_title1(inputs)
	if (locale === "sv") return sv_store_creatorcode_title1(inputs)
	if (locale === "vi") return vi_store_creatorcode_title1(inputs)
	if (locale === "tr") return tr_store_creatorcode_title1(inputs)
	if (locale === "cs") return cs_store_creatorcode_title1(inputs)
	if (locale === "bg") return bg_store_creatorcode_title1(inputs)
	if (locale === "ru") return ru_store_creatorcode_title1(inputs)
	if (locale === "uk") return uk_store_creatorcode_title1(inputs)
	if (locale === "ar") return ar_store_creatorcode_title1(inputs)
	if (locale === "hi") return hi_store_creatorcode_title1(inputs)
	if (locale === "th") return th_store_creatorcode_title1(inputs)
	if (locale === "ja") return ja_store_creatorcode_title1(inputs)
	if (locale === "zh-CN") return zh_cn2_store_creatorcode_title1(inputs)
	if (locale === "zh-Hant") return zh_hant1_store_creatorcode_title1(inputs)
	return ko_store_creatorcode_title1(inputs)
});
export { store_creatorcode_title1 as "store.creatorCode.title" }